import Loadable from "react-loadable";
import LoadingView from "../components/Chunks/LoadingView";
import _HeaderWidgets from "./header-widgets";
import {EmailVerificationPage as _EmailVerificationPage, PasswordUpdatePage as _PasswordUpdatePage } from "./authentication";

export const HeaderWidgets = _HeaderWidgets;
export const EmailVerificationPage = _EmailVerificationPage;
export const PasswordUpdatePage = _PasswordUpdatePage;

export const ErroraComponent = Loadable({
    loader: () => import("./errora" /* webpackChunkName: "Errora" */),
    loading: LoadingView
});

export const SpotlightTab = Loadable({
    loader: () => import("./spotlight/" /* webpackChunkName: "FeatureSpotlight" */),
    loading: LoadingView
});

export const AuditTab = Loadable({
    loader: () => import('./audit' /* webpackChunkName: "Audit" */).then(module => module.AuditTab),
    loading: LoadingView
});

export const AuditComponent = Loadable({
    loader: () => import('./audit' /* webpackChunkName: "Audit" */).then(module => module.AuditComponent),
    loading: LoadingView
});

export const AuditManagementTab = Loadable({
    loader: () => import('./audit' /* webpackChunkName: "Audit" */).then(module => module.AuditManagementTab),
    loading: LoadingView
});

export const MonitoringPage = Loadable({
    loader: () => import('./monitoring' /* webpackChunkName: "Monitoring" */),
    loading: LoadingView
});

export const FabricViewTab = Loadable({
    loader: () => import('./fabric-view' /* webpackChunkName: "FabricView" */),
    loading: LoadingView
});

export const CustomerSuccessTab = Loadable({
  loader: () => import('./customer-success' /* webpackChunkName: "CustomerSuccess" */),
  loading: LoadingView
});

export const CVS = Loadable({
    loader: () => import('./cvs' /* webpackChunkName: "CVS" */),
    loading: LoadingView
});

export const prefetch = [FabricViewTab];
